export default function PrivacyPolicyPage() {
  return <iframe src="/legal/privacy-policy.html" className="w-screen px-10" title="Privacy Policy"></iframe>
}
